// extracted by mini-css-extract-plugin
export default {"noMessagesContainer":"GeneralChat_noMessagesContainer__bBZdY","container":"GeneralChat_container__1sACf"};